import store from '../../store';
import { freeRoutes, availableRoutes } from '../helpers/getAppRoutes';

export function checkAvailability(route) {
  if (freeRoutes.find(r => r.name === route.name)) return;

  if (route.query && route.query.token && route.query.refreshToken) {
    localStorage.setItem('token', route.query.token);
    localStorage.setItem('refreshToken', route.query.refreshToken);
  }
  const account = store.state.loggedAccount && store.state.loggedAccount.account;
  if (!account) throw { path: '/login', params: { nextUrl: route.fullPath } };

  const isAvailableRoute = availableRoutes[account.role].find(r => r.name === route.name);
  if (isAvailableRoute) return true;

  throw { path: '/404' };
}
